/**
 * @file
 * Size the webinar side panels.
 *
 * Slido keeps the video player height. The agenda grows toward the sticky
 * footer and stops 60px above it, unless its own content is shorter.
 */

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.syncPanelHeightsWithVideo = {
    attach: function (context) {
      // Ensure this behavior only runs once.
      once('syncPanelHeightsWithVideo', 'body', context).forEach(function () {
        const lgBreakpoint = 992;
        const footerGap = 60;

        /**
         * Distance from the agenda box to 60px above the sticky footer.
         */
        function agendaAvailableHeight(panel) {
          const footerEl = document.querySelector('.page-webinar__footer');
          const limitTop = footerEl
            ? footerEl.getBoundingClientRect().top
            : window.innerHeight;

          return Math.floor(limitTop - panel.getBoundingClientRect().top - footerGap);
        }

        /**
         * Height the agenda needs when it is not capped.
         * Reset any previous inline height first, so a short agenda is not
         * reported as tall as the last capped size.
         */
        function agendaNaturalHeight(panel) {
          const previousHeight = panel.style.height;
          panel.style.height = 'auto';

          const activePane = panel.querySelector('.tab-pane.active');
          const naturalHeight = activePane
            ? activePane.scrollHeight
            : panel.scrollHeight;

          panel.style.height = previousHeight;
          return naturalHeight;
        }

        /**
         * Keep Slido aligned with the video, and let the agenda fill the
         * space down to the footer.
         */
        function adjustHeights() {
          const isLg = window.innerWidth >= lgBreakpoint;
          const videoEl = document.querySelector('.tcfw_video_player');
          const contentPanels = document.querySelectorAll('#webinar-information-content');

          if (!videoEl && !contentPanels.length) {
            return;
          }

          if (isLg) {
            if (videoEl) {
              const videoHeight = videoEl.getBoundingClientRect().height;
              document.querySelectorAll('.tc-slido').forEach(panel => {
                panel.style.height = `${videoHeight}px`;
              });
            }

            contentPanels.forEach(panel => {
              const availableHeight = agendaAvailableHeight(panel);
              const naturalHeight = agendaNaturalHeight(panel);

              // A long agenda stops 60px above the footer. A short one keeps
              // its own height, so the panel does not stretch to fill the gap.
              if (availableHeight > 0 && naturalHeight > availableHeight) {
                panel.style.height = `${availableHeight}px`;
              }
              else if (naturalHeight > 0) {
                panel.style.height = `${naturalHeight}px`;
              }
              else {
                panel.style.height = '';
              }
            });
          }
          else {
            contentPanels.forEach(panel => {
              panel.style.height = '';
            });

            document.querySelectorAll('.tc-slido').forEach(panel => {
              panel.style.height = '560px';
            });
          }
        }

        adjustHeights();

        let resizeTimeout = null;
        function scheduleAdjust() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(adjustHeights, 250);
        }

        window.addEventListener('resize', scheduleAdjust);
        window.addEventListener('load', adjustHeights);

        const tablist = document.querySelector('#webinar-information-tab');
        if (tablist) {
          tablist.addEventListener('shown.bs.tab', adjustHeights);
        }

        if (window.ResizeObserver) {
          const observer = new ResizeObserver(scheduleAdjust);
          const videoPlayer = document.querySelector('.tcfw_video_player');
          const footerEl = document.querySelector('.page-webinar__footer');
          const headerEl = document.querySelector('.page-webinar__header');

          if (videoPlayer) {
            observer.observe(videoPlayer);
          }
          if (footerEl) {
            observer.observe(footerEl);
          }
          if (headerEl) {
            observer.observe(headerEl);
          }
        }
      });
    }
  };

})(Drupal, once);
